export default {"src":"/_next/static/media/spiritory_white_logo.7287d75d.svg","height":56,"width":276,"blurWidth":0,"blurHeight":0};